import {BiologicsFeature, Capability} from 'auth/capabilities/CapabilityFeatureConstants';
import isCapabilityEnabledForTenant from 'auth/capabilities/isCapabilityEnabledForTenant';
import {isFeatureEnabled} from 'auth/feature-enablement/FeatureStatus';
import BenchlingConfig from 'BenchlingConfig';

function getBiologicsEnablementSignals(): {
  isEnabledByLegacyFlag: boolean;
  isEnabledByTenantCapability: boolean;
} {
  return {
    isEnabledByLegacyFlag: BenchlingConfig.MOLBIO_ENABLE_ANTIBODY_ENTITIES,
    isEnabledByTenantCapability: isCapabilityEnabledForTenant(Capability.BIOLOGICS),
  };
}

export function isBiologicsEnabled(): boolean {
  const {isEnabledByLegacyFlag, isEnabledByTenantCapability} = getBiologicsEnablementSignals();

  return isEnabledByLegacyFlag || isEnabledByTenantCapability;
}

function canUseBiologicsFeature(requiredBiologicsFeature: BiologicsFeature): boolean {
  const {isEnabledByLegacyFlag, isEnabledByTenantCapability} = getBiologicsEnablementSignals();

  if (!isEnabledByLegacyFlag && !isEnabledByTenantCapability) {
    return false;
  }

  // During the Biologics capability migration, legacy flag-only tenants should continue using
  // Biologics without per-user capability checks. Once Biologics is fully migrated, remove this bridge
  // and require capability feature checks whenever Biologics is enabled.
  // TODO(BNCH-154656): Remove legacy flag-only bypass after Biologics capability migration.
  if (isEnabledByLegacyFlag && !isEnabledByTenantCapability) {
    return true;
  }

  return isFeatureEnabled({feature: requiredBiologicsFeature});
}

export function canReadBiologics(): boolean {
  return canUseBiologicsFeature(BiologicsFeature.BIOLOGICS_OPEN);
}

export function canCreateBiologics(): boolean {
  return canUseBiologicsFeature(BiologicsFeature.BIOLOGICS_CREATE);
}

export function canEditBiologics(): boolean {
  return canUseBiologicsFeature(BiologicsFeature.BIOLOGICS_EDIT);
}
